var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[(_vm.hasRole(['SuperAdmin', 'Staff', 'Exec']))?_c('q-agent-lead-order-submenu'):_c('q-my-leads-submenu'),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('q-approve-lead-credit-requests-data-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }